// extracted by mini-css-extract-plugin
export default {"dialog":"rkrKfIF2LaYVTFLG"};